import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface AdminLangContextValue {
  lang: string;
  setLang: (lang: string) => void;
}

const AdminLangContext = createContext<AdminLangContextValue>({
  lang: 'el',
  setLang: () => {},
});

const STORAGE_KEY = 'botilia_admin_lang';

export function AdminLangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<string>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'el';
    } catch {
      return 'el';
    }
  });

  const setLang = useCallback((newLang: string) => {
    setLangState(newLang);
    try {
      localStorage.setItem(STORAGE_KEY, newLang);
    } catch {
      // ignore storage errors
    }
  }, []);

  return (
    <AdminLangContext.Provider value={{ lang, setLang }}>
      {children}
    </AdminLangContext.Provider>
  );
}

export function useAdminLang() {
  return useContext(AdminLangContext);
}
